import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { BaseButton } from './BaseButton.js';

/**
 * An icon-only button component that renders as a button element.
 * Requires an icon and aria-label for accessibility.
 *
 * @component
 */
const IconButton = forwardRef(({ icon, className, ...restProps }, ref) => {
    const iconOnlyClassName = classNames("tds-btn--icononly", className);
    return (React.createElement(BaseButton, { ...restProps, label: icon, className: iconOnlyClassName, ref: ref }));
});
IconButton.displayName = "IconButton";

export { IconButton };
//# sourceMappingURL=IconButton.js.map
